// Canonical booking statuses — must stay in sync with the API's BOOKING_STATUSES
// (tripnester-api: src/modules/booking/domain/booking.entity.ts). The admin status
// override endpoint (PUT /admin/bookings/:id/status) validates against this exact set.
export const BOOKING_STATUS_OPTIONS: {
  value: string;
  label: string;
  description: string;
}[] = [
  {
    value: "created",
    label: "Created",
    description: "Booking has been created",
  },
  {
    value: "awaiting_payment",
    label: "Awaiting Payment",
    description: "Waiting for payment confirmation",
  },
  {
    value: "payment_received",
    label: "Payment Received",
    description: "Payment has been confirmed",
  },
  { value: "started", label: "Started", description: "Booking has started" },
  {
    value: "processing",
    label: "Processing",
    description: "Booking is being processed with the provider",
  },
  {
    value: "waiting_confirmation",
    label: "Waiting Confirmation",
    description: "Awaiting provider confirmation",
  },
  {
    value: "confirmed",
    label: "Confirmed",
    description: "Booking is confirmed and active",
  },
  { value: "completed", label: "Completed", description: "Stay completed" },
  { value: "failed", label: "Failed", description: "Booking has failed" },
  {
    value: "payment_failed",
    label: "Payment Failed",
    description: "Payment processing failed",
  },
  {
    value: "requested_cancellation",
    label: "Requested Cancellation",
    description: "Cancellation requested, not yet processed",
  },
  {
    value: "cancelled",
    label: "Cancelled",
    description: "Booking has been cancelled",
  },
  {
    value: "rejected_cancellation",
    label: "Rejected Cancellation",
    description: "Cancellation request was rejected",
  },
  { value: "refunded", label: "Refunded", description: "Booking refunded" },
];

export const BOOKING_STATUS_CHOICES = BOOKING_STATUS_OPTIONS.map((o) => ({
  id: o.value,
  name: o.label,
}));
